import React, { useEffect, useState, useRef } from 'react';

interface Quote {
  id: number;
  text: string;
  author: string;
}

const Hero: React.FC = () => {
  const [videoError, setVideoError] = useState<boolean>(false);
  const [currentQuote, setCurrentQuote] = useState<Quote | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  
  const quotes: Quote[] = [
    { id: 1, text: "Sobald du den Flug gekostet hast, wirst du für immer auf der Erde wandeln mit den Augen zum Himmel gerichtet, denn dort warst du, und dorthin wirst du immer zurückkehren wollen.", author: "Leonardo da Vinci" },
    { id: 2, text: "Das Fliegen ist der Beweis, dass wir mit Willenskraft das Unmögliche erreichen können.", author: "Eddie Rickenbacker" },
    { id: 3, text: "Die Luft dort oben in den Wolken ist rein und fein, erfrischend und köstlich. Und warum sollte sie das nicht sein? Es ist dieselbe, die die Engel atmen.", author: "Mark Twain" },
    { id: 4, text: "Manchmal fühlt sich das Fliegen zu göttlich an, um von Menschen erreicht zu werden. Manchmal scheint die Welt von oben zu schön, zu wunderbar, zu fern für menschliche Augen.", author: "Charles A. Lindbergh" },
    { id: 5, text: "Der Himmel ist nicht die Grenze, er ist das Zuhause für diejenigen, die die Luftfahrt lieben.", author: "Anonym" }
  ];
  
  useEffect(() => {
    // Zufälliges Zitat beim Laden auswählen
    const randomIndex = Math.floor(Math.random() * quotes.length);
    setCurrentQuote(quotes[randomIndex]);
    
    // Log when video loads or fails
    const video = videoRef.current;
    if (video) {
      video.addEventListener('loadeddata', () => {
        console.log('Video loaded successfully');
      });
      
      video.addEventListener('error', (e) => {
        console.error('Error loading video:', e);
        setVideoError(true);
      });
    }
    
    return () => {
      if (video) {
        video.removeEventListener('loadeddata', () => {});
        video.removeEventListener('error', () => {});
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToNextSection = () => {
    const aboutSection = document.getElementById('ueber-uns');
    if (aboutSection) {
      const isMobile = window.innerWidth < 768;
      const headerHeight = 64; // Header Höhe
      
      if (isMobile) {
        // Mobile: Einfache Berechnung mit Verzögerung
        setTimeout(() => {
          const extraSpace = 10; // Gleicher Offset wie in der Navigation
          const targetPosition = aboutSection.offsetTop + extraSpace - headerHeight;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }, 100);
      } else {
        // Desktop: Direkte Berechnung
        const extraSpace = 80; // Gleicher Offset wie in der Navigation
        const targetPosition = aboutSection.offsetTop + extraSpace - headerHeight;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      // Fallback: zur Hero-Höhe scrollen
      const heroHeight = window.innerHeight * 0.8;
      window.scrollTo({
        top: heroHeight,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="relative">
      <div className="w-full h-[60vh] md:h-[70vh] lg:h-[80vh] overflow-hidden bg-gray-900">
        {!videoError ? (
          <video 
            ref={videoRef}
            className="w-full h-full object-cover object-center"
            autoPlay 
            muted 
            loop 
            playsInline
            preload="auto"
            poster="/content/Flugsportverein_Bilder_2.jpg"
            onError={() => setVideoError(true)}
            onLoadStart={() => console.log('Video loading started')}
          >
            {/* Updated video source to use Timeline 1.mp4 */}
            <source src="/videos/Timeline 1.mp4" type="video/mp4" />
            <source src="/videos/Timeline%201.mp4" type="video/mp4" />
            Ihr Browser unterstützt das Video-Element nicht.
          </video>
        ) : (
          <img 
            src="/content/Flugsportverein_Bilder_2.jpg" 
            alt="Flugsportverein Otto Lilienthal" 
            className="w-full h-full object-cover object-center"
          />
        )}
        <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col items-center justify-center">
          <div className="text-center max-w-4xl mx-auto px-4">
            {currentQuote && (
              <>
                <blockquote className="text-white text-2xl md:text-3xl lg:text-4xl font-serif italic leading-relaxed drop-shadow-2xl mb-4">
                  „{currentQuote.text}"
                </blockquote>
                <cite className="text-white text-lg md:text-xl font-medium not-italic drop-shadow-2xl">
                  — {currentQuote.author}
                </cite>
              </>
            )}
          </div>
          
          {/* Mehr erfahren Button */}
          <button
            onClick={scrollToNextSection}
            className="mt-8 px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-300"
          >
            Mehr erfahren
          </button>
          
          {/* Scroll-Indikator Pfeil */}
          <div className="mt-6 animate-bounce">
            <svg 
              className="w-6 h-6 text-white cursor-pointer" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
              onClick={scrollToNextSection}
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero; 